import React from 'react';
import { Link } from 'react-router-dom';
import { Box, Typography, Button } from '@mui/material';
import { businessInfo } from '../config/info';
import buddhaBg from '../assets/buddha.jpeg';

const Hero = () => (
  <Box
    sx={{
      minHeight: '90vh',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      textAlign: 'center',
      px: 3,
      py: 8,
      position: 'relative',
      overflow: 'hidden',
      backgroundImage: `url(${buddhaBg})`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
    }}
  >
    <Box
      sx={{
        position: 'absolute',
        inset: 0,
        background: 'linear-gradient(180deg, rgba(44,41,38,0.75) 0%, rgba(44,41,38,0.6) 50%, rgba(44,41,38,0.8) 100%)',
      }}
    />
    <Box
      sx={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23fff' fill-opacity='0.03'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
        opacity: 0.5,
      }}
    />
    <Box sx={{ position: 'relative', zIndex: 1, maxWidth: 720 }}>
      <Typography
        variant="overline"
        sx={{
          letterSpacing: 4,
          color: 'rgba(250,248,245,0.9)',
          fontWeight: 500,
          fontSize: '0.85rem',
          mb: 2,
          display: 'block',
        }}
      >
        {businessInfo.tagline}
      </Typography>
      <Typography
        component="h1"
        sx={{
          fontFamily: "'Cormorant Garamond', Georgia, serif",
          fontSize: { xs: 'clamp(2.5rem, 10vw, 4.5rem)', md: '4.5rem' },
          fontWeight: 500,
          letterSpacing: '-0.02em',
          lineHeight: 1.1,
          color: 'var(--color-cream)',
          mb: 3,
        }}
      >
        Chan's Nest Inn
      </Typography>
      <Typography
        component="p"
        sx={{
          fontSize: '1.125rem',
          color: 'rgba(250,248,245,0.9)',
          maxWidth: 560,
          mx: 'auto',
          mb: 1.5,
          lineHeight: 1.7,
        }}
      >
        A serene retreat in <strong>Sholayar Dam</strong> — one of the preferred{' '}
        <strong>resorts and guest rooms near Valparai</strong> for hill-station travellers.
      </Typography>
      <Typography
        component="p"
        sx={{
          fontSize: '1rem',
          color: 'rgba(250,248,245,0.82)',
          maxWidth: 520,
          mx: 'auto',
          mb: 4,
          lineHeight: 1.65,
        }}
      >
        Book comfortable <strong>accommodation in Valparai &amp; Sholayar</strong> — quiet rooms,
        mountain air, and warm hospitality on EB Road, Valparai 642125.
      </Typography>
      <Button
        component={Link}
        to="/book"
        variant="contained"
        size="large"
        sx={{
          px: 4,
          py: 1.75,
          fontSize: '1rem',
          fontWeight: 600,
          textTransform: 'none',
          borderRadius: 2,
          bgcolor: 'var(--color-accent)',
          '&:hover': { bgcolor: 'var(--color-accent-light)' },
        }}
      >
        Book Your Stay
      </Button>
    </Box>
  </Box>
);

export default Hero;
